<div
  class="min-h-[75vh] flex items-center justify-center bg-linear-to-b from-[#F3F9FB] via-[#F8FCFD] to-white px-4 py-12 bg-animate-gradient"
>
  <div
    class="w-full max-w-2xl text-center glass-card rounded-2xl p-8 md:p-12 relative overflow-hidden transition-all duration-300 hover:shadow-xl"
  >
    <!-- Decorative Floating Shapes -->
    <div
      class="absolute -top-10 -left-10 w-40 h-40 bg-[#2596BE]/10 rounded-full blur-2xl animate-float"
    ></div>
    <div
      class="absolute -bottom-10 -right-10 w-40 h-40 bg-[#0D3543]/5 rounded-full blur-2xl animate-float"
      style="animation-delay: 2s"
    ></div>

    <div class="relative z-10 flex flex-col items-center">
      <!-- Tag Badge -->
      <span
        class="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-xs font-semibold bg-[#2596BE]/10 text-[#2596BE] uppercase tracking-wider mb-6 animate-pulse"
      >
        <span class="w-2 h-2 rounded-full bg-[#2596BE]"></span>
        {{ 'inProgress.comingSoon' | translate }}
      </span>

      <!-- Title & Description -->
      <h1
        class="text-3xl md:text-4xl lg:text-5xl font-semibold text-[#0D3543] mb-4 tracking-tight leading-tight"
      >
        {{ 'inProgress.title' | translate }}
      </h1>

      <p
        class="text-white-darkest text-base md:text-lg font-normal leading-relaxed max-w-lg mb-8"
      >
        {{ 'inProgress.description' | translate }}
      </p>

      <!-- Action Button -->
      <a
        routerLink="/home"
        class="inline-flex items-center gap-3 px-8 py-3.5 bg-linear-to-r from-[#2596BE] to-[#1E7898] hover:from-[#1E7898] hover:to-[#0D3543] text-white font-medium rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0 cursor-pointer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 rtl:rotate-180"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M10 19l-7-7m0 0l7-7m-7 7h18"
          />
        </svg>
        <span>{{ 'inProgress.backHome' | translate }}</span>
      </a>
    </div>
  </div>
</div>
